export enum AccessLevel {
  god = 1000,
  superAdmin = 500,
  admin = 100,
  platinum = 50,
  gold = 25,
  premium = 10,
  trial = 5,
  free = 1,
  deactivated = -1,
  restricted = -10,
}

const ACCESS_LEVEL_IDS: Partial<Record<string, AccessLevel>> = {
  GOD: AccessLevel.god,
  SUPER_ADMIN: AccessLevel.superAdmin,
  ADMIN: AccessLevel.admin,
  PLATINUM: AccessLevel.platinum,
  GOLD: AccessLevel.gold,
  PREMIUM: AccessLevel.premium,
  TRIAL: AccessLevel.trial,
  FREE: AccessLevel.free,
  DEACTIVATED: AccessLevel.deactivated,
  RESTRICTED: AccessLevel.restricted,
};

export function accessLevelFromString(value: string): AccessLevel {
  const level = ACCESS_LEVEL_IDS[value.toUpperCase()];
  if (level === undefined) throw new Error(`Unknown access level: ${value}`);
  return level;
}

const ACCESS_LEVEL_STRINGS = Object.fromEntries(
  Object.entries(ACCESS_LEVEL_IDS).map(([k, v]) => [v, k]),
) as Record<AccessLevel, string>;

export function accessLevelToString(level: AccessLevel): string {
  return ACCESS_LEVEL_STRINGS[level];
}
